import { inject, computed } from 'vue'
import type { Ref } from 'vue'

export default function(userCareer: Ref<UserLeadInfo>) {
  // constants
  const PROFESSION_DOMAINS = inject<Record<string, string[]>>('PROFESSION_DOMAINS')!

  /**
   * 「担当領域」を表示するかどうか
   */
  const isShowProfessionDomain = computed<boolean>(() => {
    return (
      !!userCareer.value.profession &&
      !!PROFESSION_DOMAINS[userCareer.value.profession.value as string] &&
      !!PROFESSION_DOMAINS[userCareer.value.profession.value as string].length
    )
  })

  return {
    // constants
    PROFESSION_DOMAINS,

    // computed
    isShowProfessionDomain,
  }
}
